import React from "react";
import ProductCard from "./ProductCard";
import { ArrowUpRight } from "lucide-react";

const ProductGrid = ({ id, eyebrow, title, italic, items, seeAllLabel = "View all" }) => {
  return (
    <section id={id} className="bg-[#0b0b0c] py-24 border-t border-[#1c1c1e]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.4em] mb-4">
              {eyebrow}
            </div>
            <h2 className="font-serif text-[#f4ead5] text-4xl md:text-5xl">
              {title} <span className="italic">{italic}</span>
            </h2>
          </div>
          <a
            href="#"
            className="hidden md:inline-flex items-center gap-2 text-[#e9d9b0] hover:text-[#c9a24a] text-sm transition-colors"
          >
            {seeAllLabel} <ArrowUpRight size={16} />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {items.map((p) => (
            <ProductCard key={p.slug} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
